import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { FieldsService } from 'src/app/services/fields.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-filter-users',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterUsersComponent implements OnInit {
  public openFilter: boolean = false;
  @Output() enterEvent = new EventEmitter<boolean>();
  @Output() filtersEvent = new EventEmitter<any>();

  @Input() filters = {
    value: '',
    is_active: true,
    field: 0,
  }

  public status: any = ['IMPLEMENTED', 'PENDING', 'INFORMED'];
  fields: any[] = [];

  constructor(
    private popoverController: PopoverController,
    private notificationsService: NotificationsService,
    public loadingService: LoadingService,
    private fieldService: FieldsService
  ) {

    fieldService.getFields().subscribe((resp) => {
      this.fields = resp;
    })
  }

  ngOnInit() {
    
  }

  close() {
    this.enterEvent.next(this.openFilter);
  }

  confirm(){
    this.filtersEvent.next(this.filters)
    this.enterEvent.next(this.openFilter);
  }
}
